import { useUsersStore } from '@/stores/users'
import { useUserFilterStore } from '@/stores/userFilter'
import { useDebounceFn } from '@vueuse/core'
import { storeToRefs } from 'pinia'

const useUserFilters = () => {
	const { setFiltersValue, resetFilters } = useUsersStore()
	const { filters } = storeToRefs(useUsersStore())
	
	// Usar también el nuevo store de filtros
	const userFilterStore = useUserFilterStore()

	const setSearchFilter = useDebounceFn((search: string) => {
		setFiltersValue('search', search)
		userFilterStore.setFilterValue('search', search)
	}, 800)

	// Mantener el valor por defecto del store (name) en lugar de forzar 'all'
	filters.value.sortDirection = filters.value.sortDirection || 'asc'

	// Función para obtener parámetros limpios (sin valores nulos)
	const getCleanFilters = () => {
		return userFilterStore.getCleanParams()
	}

	return {
		filters,
		setFiltersValue,
		setSearchFilter,
		resetFilters,
		getCleanFilters,
		userFilterStore,
	}
}

export default useUserFilters
